import axios from 'axios'
// import {
//   Message,
//   MessageBox
// } from 'element-ui'
import store from '../store'
import {
  phpgetToken
} from '@/utils/auth'
import Vue from 'vue'

// 创建axios实例
const service = axios.create({
  // baseURL:'/npapi',
  // baseURL:process.env.NP_API, // api的base_url
  baseURL: '/npapi', // api的base_url
  timeout: 15000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {

  if (store.getters.token) {
    config.headers['Authorization'] = phpgetToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['universityCode'] = 111 // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['Api-Version'] = '2.0.0'
    // config.headers['Content-Type'] = 'multipart/form-data'
    // config.headers['Content-Type'] = 'multipart/form-data';
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
   
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */

    const res = response.data
    if (res.code !== 200 && res.code !== 201 && res.code !== 0 && res.code !== 3 && res.code !== 2 && res.code !== 1 && res.code !== 500 && res.code !== 206 && res.code !== 205 && res.code !== 300 && res.code !== 203 && res.code !== 202 && res.code !== -2) {
      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      // console.log(2222)
      return Promise.reject(response)
      // return Promise.reject('error')
    } else {
      // console.log(66666)
      // Promise.resolve(res)
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (error.response) {
      const duration = 2
      switch (error.response.status) {
        case 500:
          Vue.prototype.$message({
            message: '服务器提了一个问题',
            type: 'error',
            duration: duration * 1000
          })
          break
        case 400:
           Vue.prototype.$message({
              message: error.response.data.message,
              type: 'error'
            })
          break
        case 422:
         Vue.prototype.$message({
            message: error.response.data.message,
            type: 'error',
            duration: duration * 1000
          })
          break
        case 429:
         Vue.prototype.$message({
            message: '操作太频繁，请稍后再试',
            type: 'error',
            duration: duration * 1000
          })
          break
        case 401:
          location.reload()
          break
        case 403:
          Vue.prototype.$message({
            message: '您没有权限访问该服务',
            type: 'error',
            duration: duration * 1000
          })
          break
        case 404:
          Vue.prototype.$message({
            message: '您访问的服务不存在',
            type: 'error',
            duration: duration * 1000
          })
          break
        default:
         Vue.prototype.$message({
            message: '未知问题',
            type: 'error',
            duration: duration * 1000
          })
          break
      }
    } else {
      Vue.prototype.$message({
        message: error.response.data.message,
        type: 'error',
        duration: duration * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
